export enum CriteriaEnum {
    CLE_VERTE = '1079',
    FLOCON_VERT = '1080',
}